import { styled } from 'styled-components';
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
} from '@mui/material';

export const StyledDialog = styled(MuiDialog)`
  & .MuiDialog-paper {
    max-width: 720px;
    width: calc(100% - 48px);
    margin: 24px auto;
    border-radius: 12px;
  }
`;

export const StyledDialogTitle = styled(MuiDialogTitle)`
  padding: 24px 24px 0 24px;
`;

export const ProgressContainer = styled('div')`
  padding: 0 24px 16px;
`;

export const ProgressBarWrapper = styled('div')`
  width: 100%;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressFill = styled('div')<{ sx?: Record<string, unknown> }>`
  height: 100%;
  background: #1D9E75;
  transition: width 0.3s ease;
  border-radius: 3px;
`;

export const SectionLabel = styled('span')`
  font-size: 13px;
  font-weight: 600;
  color: #1D9E75;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TimeEstimate = styled('span')`
  font-size: 12px;
  color: #757575;
  white-space: nowrap;
`;

export const QuestionnaireContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const QuestionBox = styled('div')<{ invalid?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: ${({ invalid }) => invalid ? '2px solid #d32f2f' : '2px solid transparent'};
  border-radius: 8px;
  background: ${({ invalid }) => invalid ? '#fff5f5' : 'transparent'};
  padding: ${({ invalid }) => invalid ? '12px' : '0'};
  transition: border-color 0.2s ease, background 0.2s ease;
`;

export const QuestionText = styled('p')`
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: #212121;
`;

export const RequiredStar = styled('span')<{ sx?: Record<string, unknown> }>`
  color: #d32f2f;
  font-weight: 700;
  margin-left: 4px;
`;

export const OptionsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const PillOption = styled('button')<{ active: boolean }>`
  padding: 8px 16px;
  border-radius: 20px;
  border: 2px solid ${({ active }) => (active ? '#1D9E75' : '#e0e0e0')};
  background: ${({ active }) => (active ? '#e8f5f0' : '#ffffff')};
  color: ${({ active }) => (active ? '#1D9E75' : '#424242')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
  white-space: normal;
  line-height: 1.3;

  &:hover {
    border-color: #1D9E75;
    background: #f0faf7;
  }

  &:focus {
    outline: 2px solid #1D9E75;
    outline-offset: 2px;
  }
`;

export const PillOptionActive = styled('span')`
  display: inline-block;
`;

export const CheckboxOption = styled('div')<{ active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? '#1D9E75' : '#e0e0e0')};
  background: ${({ active }) => (active ? '#f0faf7' : '#ffffff')};
  cursor: pointer;
  transition: all 0.15s ease;
  width: 100%;

  &:hover {
    border-color: #1D9E75;
    background: #f8fdfa;
  }
`;

export const CheckboxOptionActive = styled('span')<{ checked: boolean }>`
  display: inline-flex;
  color: ${({ checked }) => (checked ? '#1D9E75' : 'inherit')};
`;

export const NrsGrid = styled('div')`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

export const NrsCell = styled('button')<{ active: boolean }>`
  width: 40px;
  height: 40px;
  border: 2px solid ${({ active }) => (active ? '#1D9E75' : '#e0e0e0')};
  border-radius: 8px;
  background: ${({ active }) => (active ? '#1D9E75' : '#ffffff')};
  color: ${({ active }) => (active ? '#ffffff' : '#424242')};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #1D9E75;
    background: ${({ active }) => (active ? '#1D9E75' : '#f0faf7')};
  }

  &:focus {
    outline: 2px solid #1D9E75;
    outline-offset: 2px;
  }
`;

export const NrsCellActive = styled('span')<{ active: boolean }>`
  display: inline-block;
  color: ${({ active }) => (active ? '#ffffff' : 'inherit')};
`;

export const NrsLabel = styled('span')`
  font-size: 11px;
  color: #757575;
`;

export const BsfsRow = styled('div')<{ active: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  border: 2px solid ${({ active }) => (active ? '#1D9E75' : 'transparent')};
  background: ${({ active }) => (active ? '#f0faf7' : 'transparent')};
  cursor: pointer;
  transition: all 0.15s ease;
  gap: 12px;

  &:hover {
    background: #f8fdfa;
  }

  &:focus {
    outline: 2px solid #1D9E75;
    outline-offset: 2px;
  }
`;

export const BsfsLabel = styled('div')<{ active: boolean }>`
  flex: 1;
  color: ${({ active }) => (active ? '#1D9E75' : 'inherit')};
`;

export const RecallHint = styled('p')`
  font-size: 13px;
  color: #757575;
  font-style: italic;
  margin: 0 0 4px 0;
`;



export const ThankYouBox = styled('div')`
  text-align: center;
  padding: 16px 0;
`;

export const ReferencesSection = styled('div')`
  text-align: left;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
`;

export const ReferencesTitle = styled('p')`
  text-align: center;
  font-weight: 700;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
`;

export const ReferenceItem = styled('ol')`
  list-style: decimal;
  padding-left: 24px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  & > li,
  & > li > ul > li {
    &::before {
      display: none !important;
    }
  }

  & > li::marker {
    font-weight: 700;
  }

  & > li > ul {
    list-style: disc;
    padding-left: 20px;
    margin: 4px 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

export const ReferenceTitle = styled('span')`
  font-weight: 600;
  color: #212121;
`;

export const ReferenceLink = styled('a')`
  color: #1D9E75;
  text-decoration: none;
  display: inline;

  &:hover {
    text-decoration: underline;
  }
`;


